import React, { useEffect, useState } from "react";
import { education_category } from "../../utilis/constants";
import ProviderSettingsModal from "./ProviderSettingsModal";

const inputClass =
  "w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100";

function ProviderLevelModal({
  show,
  isEditing = false,
  levelLabel = "Add New Level",
  defaultTitle = "",
  defaultCategory = "",
  saving = false,
  onClose,
  onSubmit,
}) {
  const [levelTitle, setLevelTitle] = useState(defaultTitle);
  const [category, setCategory] = useState(defaultCategory);

  useEffect(() => {
    if (show) {
      setLevelTitle(defaultTitle || "");
      setCategory(defaultCategory || "");
    }
  }, [show, defaultTitle, defaultCategory]);

  const handleSubmit = () => {
    onSubmit?.(levelTitle.trim(), category);
  };

  return (
    <ProviderSettingsModal
      show={show}
      title={isEditing ? "Edit Level" : "New Level"}
      onClose={onClose}
      onSubmit={handleSubmit}
      submitLabel={isEditing ? "Update" : "Add"}
      saving={saving}
    >
      <div className="mb-4">
        <label className="mb-1.5 block text-sm font-semibold text-gray-700">
          {levelLabel}
        </label>
        <input
          type="text"
          autoFocus
          placeholder="Enter level title"
          value={levelTitle}
          onChange={(event) => setLevelTitle(event.target.value)}
          className={inputClass}
        />
      </div>

      <div>
        <label className="mb-1.5 block text-sm font-semibold text-gray-700">
          Category
        </label>
        <select
          value={category}
          onChange={(event) => setCategory(event.target.value)}
          className={inputClass}
        >
          <option value="">Please Select</option>
          {education_category.map((head) => (
            <option key={head.title} value={head.title}>
              {head.title}
            </option>
          ))}
        </select>
      </div>
    </ProviderSettingsModal>
  );
}

export default ProviderLevelModal;
